import { Command } from "./Command";
export class PagingQuery extends Command {
    offset = null;
    limit = null;
    orderBy = null;
}
